import { FC, useCallback } from 'react';
import termsOfServiceClass from '../../assets/scss/SubscriptionDetail/TermsOfService.module.scss';
import { postMessageGtag } from '../../utils/trackClick';

export const TermsOfService: FC<{
  clickLinkFunc: (type: string) => void;
  clickCancellationLinkFunc: () => void;
}> = ({ clickLinkFunc, clickCancellationLinkFunc }) => {
  const clickLinkHandler = useCallback(
    (type: string) => {
      clickLinkFunc(type);
    },
    [clickLinkFunc]
  );

  const eventCategory = 'detailContract';

  return (
    <div className={termsOfServiceClass.termsOfService}>
      <ul>
        <li>
          お届け内容を変更される場合は、解約の申し出をしない限り、設定された頻度で継続的に商品が届く、
          <span
            className={termsOfServiceClass.textLink}
            onClick={() => {
              clickLinkHandler('SubscriptionPolicy');
              postMessageGtag('click_modal_open_SubscriptionPolicy', eventCategory);
            }}
          >
            定期購入契約ポリシー
          </span>
          であることを確認の上、変更を完了ください。
        </li>
        <li>次回配送日は、本日の5日後から60日後まで変更可能です。</li>
        <li>
          <span
            className={termsOfServiceClass.textLink}
            onClick={() => {
              clickLinkHandler('Payment');
              postMessageGtag('click_modal_open_PaymentClaim', eventCategory);
            }}
          >
            支払い方法と請求のタイミング
          </span>
        </li>
        <li>
          <span
            className={termsOfServiceClass.textLink}
            onClick={() => {
              clickLinkHandler('ReturnExchange');
              postMessageGtag('click_modal_open_ReturnExchange', eventCategory);
            }}
          >
            商品の返品・交換
          </span>
        </li>
        <li>
          <span
            className={termsOfServiceClass.textLink}
            onClick={() => {
              clickCancellationLinkFunc();
              postMessageGtag('click_modal_open_howtoPauseCancel', eventCategory);
            }}
          >
            定期便のお届けを止めるには？
          </span>
        </li>
      </ul>
    </div>
  );
};
